// extracted by mini-css-extract-plugin
export default {"navbar":"DXlCTPPkDyLshY1FxtQy"};